import { useState } from "react";

import { playerSlotWithoutHover } from "../../../figmaElements";
import { SearchedPlayer } from "../../../redux/players/SearchedPlayer.type";

type Props = {
  player?: SearchedPlayer;
  onClick: (e: React.MouseEvent) => void;
};

export const FiltersSidebarPlayerSlot = ({ player, onClick }: Props) => {
  const [hovered, setHovered] = useState(false);
  if (player) {
    return (
      <img
        onClick={onClick}
        className="w-[76px] mx-[2px] desktop:cursor-pointer"
        alt={player.cardName}
        src={`${
          import.meta.env.VITE_APP_ASSETS_BASE_URL
        }/fc25/playercards/small/${player.resourceId}.png`}
      />
    );
  } else {
    return (
      <button
        className="h-[105px] mt-1"
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={
          {
            "--fillCross": hovered ? "#7A7A7A" : "#111111",
            "--fillBackground": hovered ? "url(#hovered)" : "url(#notHovered)",
            filter: hovered
              ? "drop-shadow(0px 0px 5.8px rgba(255, 255, 255, 0.91))"
              : "drop-shadow(0px 3px 6.5px rgba(0, 0, 0, 0.91))",
          } as any
        }
      >
        {playerSlotWithoutHover}
      </button>
    );
  }
};
